// Add post to collection
export const addToCollection = async (apiCall, postId, type) => {
  try {
    const response = await apiCall(`/api/collections/${postId}/add`, {
      method: 'POST',
      body: JSON.stringify({ type })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      data: data.data,
      isNew: data.data.isNew
    };
  } catch (error) {
    throw error;
  }
};

// Remove post from collection
export const removeFromCollection = async (apiCall, postId, type) => {
  try {
    const response = await apiCall(`/api/collections/${postId}/remove`, {
      method: 'DELETE',
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      success: true,
      removed: data.data.removed,
      previousType: data.data.previousType
    };
  } catch (error) {
    throw error;
  }
};

export const getUserCollections = async (apiCall, type, limit = 20, cursor = null) => {
  try {
    const params = new URLSearchParams({ limit: limit.toString() });
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/collections/user/${type}?${params.toString()}`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      posts: data.data.collections || [],
      nextCursor: data.data.nextCursor || null,
      hasMore: data.data.hasMore || false
    };
  } catch (error) {
    throw error;
  }
};

export const fetchCustomPosts = async (
  apiCall, 
  type = 'save', 
  limit = 10, 
  cursor = null,
  isFirst = false
) => {
  try {
    const params = new URLSearchParams({ 
      limit: limit.toString() 
    });
    
    if (cursor) {
      params.append('cursor', cursor);
      if (isFirst) params.append('isFirst', 'true');
    }
    
    const response = await apiCall(`/api/collections/user/${type}?${params.toString()}`);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }
    
    return {
      posts: data.data?.collections || [],
      nextCursor: data.data?.nextCursor || null,
      hasMore: data.data?.hasMore || false
    };
  } catch (error) {
    throw error;
  }
};